export default __webpack_public_path__ + "static/media/004-love letter.f2f1d5ee.svg";